export default function generatePassword() {
  const randomString = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".charAt(Math.floor(Math.random() * 26));
  const randomInteger = Math.floor(Math.random() * 100);
  const password = String(Math.random().toString(36).slice(-8)) + randomString + randomInteger;

  return password;
}
